import { FC } from "react";
import { useTranslation } from "react-i18next";
import { AccordionItemCategory } from "./AccordionItemCategory";
import { AccordionItemEnd } from "./AccordionItemEnd";
import { AccordionItemEventType } from "./AccordionItemEventType";
import { AccordionItemFormat } from "./AccordionItemFormat";
import { AccordionItemIndustry } from "./AccordionItemIndustry";
import { AccordionItemLocation } from "./AccordionItemLocation";
import { AccordionItemOrganizationalUnits } from "./AccordionItemOrganizationalUnits";
import { AccordionItemOrganizer } from "./AccordionItemOrganizer";
import { AccordionItemRegion } from "./AccordionItemRegion";
import { AccordionItemStart } from "./AccordionItemStart";
import { AccordionItemTag } from "./AccordionItemTag";
import { AccordionItemTargetGroup } from "./AccordionItemTargetGroup";
import { EventFilterAccordionItemsProvider } from "./EventFilterAccordionItemsProvider";

export const QuickEventFilterForm: FC = () => {
	const { t } = useTranslation();
	return (
		<EventFilterAccordionItemsProvider>
			<AccordionItemEventType name="filterItems.0.value" />
			<AccordionItemCategory name="filterItems.1.value" />
			<AccordionItemFormat name="filterItems.2.value" />
			<AccordionItemStart name="filterItems.3.value" />
			<AccordionItemEnd name="filterItems.4.value" />
			<AccordionItemIndustry name="filterItems.5.value" />
			<AccordionItemRegion name="filterItems.6.value" />
			<AccordionItemOrganizationalUnits name="filterItems.7.value" title={t("Primary organizational unit")} />
			<AccordionItemOrganizationalUnits name="filterItems.8.value" title={t("Organizational units")} />
			<AccordionItemTag name="filterItems.9.value" />
			<AccordionItemTargetGroup name="filterItems.10.value" />
			<AccordionItemLocation name="filterItems.11.value" />
			<AccordionItemOrganizer name="filterItems.12.value" />
		</EventFilterAccordionItemsProvider>
	);
};
